import { useQuery } from '@apollo/client';
import { useUser } from '../../useUser';
import { PAYMENT_METHODS_QUERY, PaymentMethodsQuery } from './paymentMethodsQuery.rest';

export const usePaymentMethodsQuery = () => {
  const {
    user: { accessToken }
  } = useUser();
  return useQuery<PaymentMethodsQuery>(PAYMENT_METHODS_QUERY, { skip: !accessToken });
};
